import React from "react";
import "./OrderCardLoader.scss";

const OrderCardLoader = () => {
  return (
    <div className="loader">
      <p className="text">
        {["L", "o", "a", "d", "i", "n", "g", ".", ".", "."].map((char, index) => (
          <span key={index} className={`letter letter${index + 1}`}>
            {char}
          </span>
        ))}
      </p>
    </div>
  );
};

export default OrderCardLoader;